import { useCallback, type ReactNode } from 'react';

import { SharedTrackingProvider } from '@web-platform/shared-universal-tracking/src/SharedTrackingContext/SharedTrackingContext';
import { trackInteractionEvent } from '@web-platform/shared-universal-tracking/src/trackInteractionEvent/trackInteractionEvent';
import { cleanEmpty } from '@web-platform/shared-universal-utils-frontend/src/helpers/cleanEmpty';

import type { SharedTrackingFns } from '@web-platform/shared-universal-types-tracking/src/SharedTrackingFns';

export const BananaSharedTrackingProvider = ({ children }: { children: ReactNode }) => {
  const trackGenericEvent = useCallback<SharedTrackingFns['trackGenericEvent']>(
    (name, allProperties) => {
      const { booleanProperties, numericProperties, properties } = cleanEmpty(allProperties);

      trackInteractionEvent({
        // ST-7029
        // @ts-expect-error InteractionEvent for Banana, BehaviouralEvent for Acorn. To remove when the SharedTracking Providers are removed, once BehaviouralEvents are fully removed.
        name,
        strings: properties,
        bools: booleanProperties,
        numbers: numericProperties,
      });
    },
    [],
  );

  return (
    <SharedTrackingProvider
      value={{
        trackGenericEvent,
      }}
    >
      {children}
    </SharedTrackingProvider>
  );
};
